import React, {  } from "react";
import ClearIcon from '@material-ui/icons/Clear';
import StyledActiveChip from "../../../customUI/ActiveChip";
import {useDigitalPR} from "../hooks/useDigitalPR";
import { useStyles } from "../styles/index.style";

const AppliedFilters = () => {
   const classes = useStyles();
   const { filterLabels, onCampaignFiltersChange, currentFilters } = useDigitalPR();

   return (
      Object.keys(filterLabels).filter((key) => currentFilters[key] !== null).map((key) => (
         <StyledActiveChip
            label={`${filterLabels[key]}: ${currentFilters[key]}`}
            className={classes.chipMargin}
            onDelete={() => onCampaignFiltersChange({[key]: null})}
            deleteIcon={<ClearIcon style={{ color: 'white' }} />}
         />
      ))
   )
}

export default AppliedFilters